module.exports = __webpack_public_path__ + "media/images/footer/WS-icon-twitter_white-d5daa20c8d7e398846ebd9d797e5b603.svg";